'use client'

import { Avatar } from '@repo/ui/Avatar'
import { ClientNameAndMatterDescription } from '@repo/ui/ClientNameAndMatterDescription'
import { CloseIcon } from '@repo/ui/CloseIcon'
import { MultipleEmailsIcon } from '@repo/ui/MultipleEmailsIcon'
import { SingleEmailIcon } from '@repo/ui/SingleEmailIcon'
import MUIButton from '@mui/material/Button'
import MUIStack from '@mui/material/Stack'
import MUITooltip from '@mui/material/Tooltip'
import PropTypes from 'prop-types'
import styles from './../../../cards/MiniMatterCard/MiniMatterCard.module.scss'

export const EmailSidebarSingleMatterCard = ({ matter, onClear, sx, conversationOrSingleEmail }) => {
  if (!matter) return <div data-testid="miniMatterCardButton" />

  return (
    <MUIStack className={`${styles.miniMatterCardButton}`} data-testid="miniMatterCardButton" sx={sx}>
      <MUIStack
        direction="row"
        alignItems="center"
        className={styles.miniMatterCard}
        data-testid="miniMatterCard"
        sx={{
          opacity: matter.isUserRestricted ? 0.6 : 1,
          cursor: matter.isUserRestricted ? 'not-allowed' : 'pointer'
        }}
      >
        {conversationOrSingleEmail === 'conversation' ? (
          <MUITooltip
            title={
              'The selected message has been saved to Matter History, and all future messages in this conversation will be saved automatically'
            }
            placement="top"
            arrow
          >
            <MUIStack direction="row" alignItems="center" justifyContent="center">
              <MultipleEmailsIcon sx={{ marginRight: '8px', pointerEvents: 'none' }} />
            </MUIStack>
          </MUITooltip>
        ) : null}

        {conversationOrSingleEmail === 'singleEmail' ? (
          <MUITooltip title={'The selected message has been saved to Matter History'} placement="top" arrow>
            <MUIStack direction="row" alignItems="center" justifyContent="center">
              <SingleEmailIcon sx={{ marginRight: '8px', pointerEvents: 'none' }} />
            </MUIStack>
          </MUITooltip>
        ) : null}

        {!conversationOrSingleEmail ? (
          <Avatar sx={{ marginRight: 2 }} feeEarnerId={matter.feeEarnerId} name={matter.feeEarnerDescription} />
        ) : null}

        <ClientNameAndMatterDescription
          clientNo={matter.clientNo}
          matterNo={matter.matterNo}
          forename={matter.forename}
          surname={matter.surname}
          matterDescription={matter.matterDescription}
          dateArchived={matter.dateArchived}
          sx={{ paddingRight: '0px !important' }}
        />

        {onClear && (
          <MUIButton onClick={onClear} sx={{ p: '20px', width: '24px', height: '24px', minWidth: 0 }}>
            <CloseIcon sx={{ width: '14px', height: '14px', ml: 1, mr: 1, opacity: 1 }} />
          </MUIButton>
        )}
      </MUIStack>
    </MUIStack>
  )
}

EmailSidebarSingleMatterCard.propTypes = {
  matter: PropTypes.object,
  onClear: PropTypes.func,
  sx: PropTypes.object,
  conversationOrSingleEmail: PropTypes.string
}
